import gql from "graphql-tag";

export const OC_GET_PROPERTY = gql`
  query property($resource: String!, $key: String!) {
    property(resource: $resource, key: $key) {
      key
      resource
      resourceId
      value
      validFrom
      validTo
    }
  }
`;
